export const toggleQuizzSatuts = (id, fields) => {
  return `mutation{updateQstatus(id:${id}){${fields.join(" ")}}}`;
};

export const createQuizMutation = (createQuizzDto) => {
  return `mutation{createQuiz(createQuizDto:{title:"${createQuizzDto.title}",is_active:${createQuizzDto.status}}){title}}`;
};

export const deleteQuizzMutation = (id) => {
  return `mutation{deleteQuiz(id:${id}){title}}`;
};

export const UpdateQuizzMutation = (id, Dto, fields) => `mutation{
  updateQuiz(updateQuizDto:{title:"${Dto.title}",is_active:${
  Dto.status
}},id:${id}){${fields.join(" ")}}
}`;

export const submitQuizAnswerMutation = (quiz_id, answers) => `mutation{
  _AnswerQuizz(quiz_id:${quiz_id},answers:{opt_ids:${answers}})
    {
      id
      title
      status
  
      sumVotes
      _answers{id
               AnswersCount
               opt_text
   
               }
     }
  
  }`;

export const _createFullQuizzMutation = (quizDto, radio_id) => {
  let opptionsDTo = `[${quizDto.answers
    .map((ele) => `{opt_text:"${ele.opt_text}",status:${ele.status}}`)
    .join(",")}]`;
  let dto = `{title:"${quizDto.title}",radio_id:${radio_id},multiChoice:${quizDto.multiChoice},status:${quizDto.status},answers:${opptionsDTo}}`;

  return `mutation{
    _createQuiz2(createQuiz2Input:${dto})
    { id
      title
      status
      sumVotes
       }
  
  }
  `;
};

export const _answerQuiz = (answers, quiz_id) => `mutation{
  _AnswerQuizz(answers:{opt_ids:[${answers.join(
    ","
  )}]},quiz_id:${quiz_id}){id title }
  }`;

export const _AnswerQuizMutation = (quiz_id, CountDto) => {
  const answers = CountDto.answersCount.map(
    (ele) => `{id:${ele.id},count:${ele.count}}`
  );

  return `mutation{
    _AnswerQuiz(quiz_id:${quiz_id},QuizAnswers:{quizCount:${
    CountDto.quizCount
  },answersCount:[${answers.join(",")}]})
    {
       id
       title
       
     }
    }`;
};

export const _UpdateChartStatus = (quiz_id, dto) => `mutation{
  _UpdateStatisticChart(id:${quiz_id},updateinput:{donutChart:${dto.donutChart},progresbarChart:${dto.progresbarChart}})
    {id
      donutChart
      progresbarChart
     }
  }`;

export const _updateQuizStatusMutation = (id) => `mutation{
  _updateAnswerStatus(Ans_id:${id})
  { 
    title
   sumVotes
  status
 
}
}`;

export const removeQuizByIdMutation = (id) => `
mutation{

  _removeQuizById(id:${id}){
        id 
        title
        status
 
       }
 
 }
`;

export const _toggleQuizzSatuts = (id) => {
  return `mutation{
    _updateQuizStatus(id:${id}){
      id
      title
      status
    }
    }`;
};

// title:"new quizz"
// status:true,
// multiChoice:false
// questions:[{opt_text:"option 1",status:true}]
